/**
 * The one route table.
 *
 * Every section used to own a router of its own, mounted by an entry point of its
 * own into a placeholder of its own. They already routed over url prefixes that
 * do not overlap, so uniting them is mostly concatenation - what matters here is
 * the order, since one table now matches urls that used to reach separate ones.
 *
 * Sections that fetch data, or bring a stylesheet of their own, do it from
 * `setup` in their own routes module; see spa/section.js.
 */
import wikiRoutes from '~/angular/app/wiki_page/routes';
import goalsRoutes from '~/angular/app/goals/mainPage/routes';
import adminStatsRoutes from '~/angular/app/admin-pages/routes';
import ahRoutes from '~/angular/app/ah/routes';
import dashboardRoutes from '~/angular/app/dashboard/routes';
import chatsRoutes from '~/angular/app/chats/routes';
import tasksRoutes from '~/angular/app/tasks/routes';
import groupRoutes from '~/angular/app/group_page/routes';
import diaryRoutes from '~/angular/app/diary_page/routes';
import mediaRoutes from '~/angular/app/pages/folders/routes';
import calendarRoutes from '~/angular/app/events/new_calendar/routes';
import communityRoutes from '~/angular/app/community_page/routes';
import storyRoutes from '~/angular/app/story_page/routes';
import iframeRoutes from '~/angular/app/iframe_page/routes';
import authRoutes from '~/angular/app/reg/routes';
import groupInviteRoutes from '~/angular/app/groups/group_email_invitation/routes';

// everything below lives under /users/, and has to be matched before the profile
// section, whose /users/:userName/ would otherwise swallow all of it
import userActivityPostRoutes from '~/angular/app/user_activity_post_page/routes';
import emailUnsubscribeRoutes from '~/angular/app/email_unsubscribe/routes';
import closeAccountRoutes from '~/angular/app/userprofile/close_account/routes';
import circleInviteRoutes from '~/angular/app/userprofile/circle_email_invitation/routes';
import circlesListRoutes from '~/angular/app/userprofile/circles_list/routes';
import profileRoutes from '~/angular/app/userprofile_page/routes';

export default [
    ...wikiRoutes,
    ...goalsRoutes,
    ...adminStatsRoutes,
    ...ahRoutes,
    ...dashboardRoutes,
    ...chatsRoutes,
    ...tasksRoutes,
    ...groupRoutes,
    ...diaryRoutes,
    ...mediaRoutes,
    ...calendarRoutes,
    ...communityRoutes,
    ...storyRoutes,
    ...iframeRoutes,
    ...authRoutes,
    ...groupInviteRoutes,

    // /users/ - narrowest first
    ...userActivityPostRoutes,
    ...emailUnsubscribeRoutes,
    ...closeAccountRoutes,
    ...circleInviteRoutes,
    ...circlesListRoutes,
    ...profileRoutes,
];
